// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.watermark-overlay_watermark__D1bmV {
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 40px;

  font-size: 24px;
  text-align: center;
}

.watermark-overlay_container__y4QNs {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;

  position: absolute;
  top: 0;

  display: flex;
  align-items: center;

  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.watermark-overlay_topLeft__eq5rX {
  align-items: flex-start;
  justify-content: flex-start;
}

.watermark-overlay_topCenter__rLdZ1 {
  align-items: flex-start;
  justify-content: center;
}

.watermark-overlay_topRight__LHPPQ {
  align-items: flex-start;
  justify-content: flex-end;
}

.watermark-overlay_bottomLeft__bdt8E {
  align-items: flex-end;
  justify-content: flex-start;
}

.watermark-overlay_bottomCenter__fkkBV {
  align-items: flex-end;
  justify-content: center;
}

.watermark-overlay_bottomRight__YZ2Yv {
  align-items: flex-end;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/watermark-overlay/watermark-overlay.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,YAAY;;EAEZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EAGzB,iBAAiB;;EAEjB,kBAAkB;EAClB,MAAM;;EAEN,aAAa;EACb,mBAAmB;;EAEnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B","sourcesContent":[".watermark {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  height: 40px;\n\n  font-size: 24px;\n  text-align: center;\n}\n\n.container {\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  position: absolute;\n  top: 0;\n\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.topLeft {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.topCenter {\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.topRight {\n  align-items: flex-start;\n  justify-content: flex-end;\n}\n\n.bottomLeft {\n  align-items: flex-end;\n  justify-content: flex-start;\n}\n\n.bottomCenter {\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.bottomRight {\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"watermark": `watermark-overlay_watermark__D1bmV`,
	"container": `watermark-overlay_container__y4QNs`,
	"topLeft": `watermark-overlay_topLeft__eq5rX`,
	"topCenter": `watermark-overlay_topCenter__rLdZ1`,
	"topRight": `watermark-overlay_topRight__LHPPQ`,
	"bottomLeft": `watermark-overlay_bottomLeft__bdt8E`,
	"bottomCenter": `watermark-overlay_bottomCenter__fkkBV`,
	"bottomRight": `watermark-overlay_bottomRight__YZ2Yv`
};
export default ___CSS_LOADER_EXPORT___;
